import { NavLink,useNavigate } from "react-router-dom";
import UserIcon from "src/assets/all-icons/user-icon.jsx";

import useProtectAction from '@/hooks/useProtectAction';
import useStateHandler from '@/hooks/useStateHandler';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import HomeIcon from '@/shared-components/icons/components/navigation/HomeIcon';
import RankingIcon from '@/shared-components/icons/components/navigation/RankingIcon';
import SearchNavbarIcon from '@/shared-components/icons/components/navigation/SearchNavbarIcon';
import SuarteWorldIcon from '@/shared-components/icons/components/navigation/SuarteWorldIcon';

const AppNavigationProtectedOption = ({ activeLink, onLinkClick }) => {

  const privateActionHandler = useProtectAction({ typeOfProtection: "USER_ACCOUNT_REQUIRED" });
  const { state } = useStateHandler();
  const navigate = useNavigate();
  
  const handleProfileClick = () => {
    privateActionHandler(() => navigate("/profile"));
  };

  if (state.user_session) {
    return (
      <UserProfileImage 
        className={`app-navigation__nav-option-profile-image ${activeLink.includes("/profile") ? "active" : ""} `}
        image={state.user_session.user_image?.image_id} 
        typeOfProfile={state.user_session.user_type} 
        onClick={() => {
          handleProfileClick();
          onLinkClick("/profile");
        }}
      />
    );
  }

  return (
    <>  
      <button 
        className={`app-navigation__nav-option profile ${activeLink === "/profile" ? "active" : ""}`} 
        aria-label="Profile"
        onClick={handleProfileClick}
      >
        <UserIcon />
      </button>
    </>
  );
};

const AppNavigationOptions = ({ activeLink, handleLinkClick }) => {
 
  return (
    <div className="app-navigation__suarte-options">
      <NavLink
        to="/"
        className={`app-navigation__nav-option home ${activeLink === "/" ? "active" : ""}`}
        aria-label="Home"
        onClick={() => handleLinkClick("/")}
        end
      >
        <HomeIcon />
      </NavLink>

      <NavLink
        to="/search"
        className={`app-navigation__nav-option search ${activeLink === "/search" ? "active" : ""}`}
        aria-label="Search"
        state={location.pathname === "/search" ? location.state : null}
        onClick={() => handleLinkClick("/search")}
      >
        <SearchNavbarIcon />
      </NavLink>

      <NavLink
        to="/suarteworld"
        className={`app-navigation__nav-option suarteworld ${activeLink === "/suarteworld" ? "active" : ""}`}
        aria-label="SuarteWorld"
        state={location.pathname === "/suarteworld" ? location.state : null}
        onClick={() => handleLinkClick("/suarteworld")}
      >
        <SuarteWorldIcon />
      </NavLink>

      <NavLink
        to="/rankings"
        className={`app-navigation__nav-option trending ${activeLink === "/rankings" ? "active" : ""}`}
        aria-label="Rankings"
        onClick={() => handleLinkClick("/rankings")}
      >
        <RankingIcon />
      </NavLink>

      <AppNavigationProtectedOption 
        activeLink={activeLink}
        onLinkClick={handleLinkClick}
      />
    </div>
  );
};

export default AppNavigationOptions;
